import api from '../../services/api';

const urlDocumentos = '/veiculos-documentos';

export default {
  listarDocumentos: () =>
    api.get(`${urlDocumentos}`).then(res => res.data),

  verificarDocumentoVencido: () =>
    api.get(`${urlDocumentos}/vencidos`).then(res => res.data),

  historicoDocumento: (veiculo_id, tipo) =>
    api.get(`${urlDocumentos}/${veiculo_id}/${tipo}/historico`).then(res => res.data),

  baixarDocumento: (veiculo_id, tipo, documento_id) =>
    api.get(`${urlDocumentos}/${veiculo_id}/${tipo}/download/${documento_id}`, { responseType: 'blob' }),

  excluirDocumento: (veiculo_id, tipo, documento_id) =>
    api.delete(`${urlDocumentos}/${veiculo_id}/${tipo}/${documento_id}`),

  cadastrarDocumento: (veiculo_id, tipo, data) =>
    api.post(`${urlDocumentos}/${veiculo_id}/${tipo}/cadastrar`, data),
};
